import { render, staticRenderFns } from "./TaxesFilters.vue?vue&type=template&id=800122a8&"
import script from "./TaxesFilters.vue?vue&type=script&lang=js&"
export * from "./TaxesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports